export { default as WxAutocomplete } from './wxAutocompleteWidget';
export { default as WxBaseWidget } from './wxBaseWidget';
export { default as WxDatePicker } from './wxDatePickerWidget';
export { default as WxImageInputWidget } from './wxImageInputWidget';
export { default as WxSwitch } from './wxSwitch';
export { default as WxTextWidget } from './wxTextWidget';
